<template>
  <div class="view intro">
    <h1>Smartour</h1>
    <h3>Makes website tour guide much easier</h3>
    <h2>⬇︎</h2>
  </div>
</template>

<script>
export default {
  mounted () {
    tour.queue([{
      el: '#app > div > h1',
      slot: `<p>This is it's name</p>`,
      options: {
        slotPosition: 'top',
        layerEvent: tour.next.bind(tour)
      }
    }, {
      el: '#app > div > h3',
      slot: `<p>This is what it does.</p>`,
      options: {
        slotPosition: 'bottom',
        layerEvent: tour.next.bind(tour)
      }
    }, {
      el: '#app > div > h2',
      slot: `<p>Scoll up to see the document</p>`,
      options: {
        slotPosition: 'top',
        layerEvent: tour.next.bind(tour)
      }
    }])

    tour.run()
  }
}
</script>

<style lang="less" scoped>
.intro {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: url('../assets/bg.png');
  background-size: 100% 100%;
  color: #fff;
  text-shadow: 0 0 10px #000;
  h1 {
    font-size: 4rem;
    border: none;
  }
  h3 {
    font-size: 1.3rem;
  }
  h2 {
    position: absolute;
    left: 50%;
    bottom: 15px;
    animation: jumping .8s infinite linear alternate;
  }
  @keyframes jumping {
    from {
      transform: translateX(-50%) translateY(-5px);
    }
    to {
      transform: translateX(-50%) translateY(5px);
    }
  }
}
</style>
